import { getAllOutboxItems, deleteOutboxItem } from "./offlineDb"
import { authenticatedSession } from "./syncPolicy"
import { discardSyncOperation } from "../redux/slices/offlineSlice"

// Persist the removal first so a storage failure leaves the action retryable.
export async function discardFailedSyncItem(dispatch, getState, itemId) {
  const checkSession = () => {
    if (!authenticatedSession(getState())) throw new Error("Sign in before removing a sync action.")
    if (getState().offline.isSyncing) throw new Error("Wait for syncing to finish, then remove this action.")
  }
  checkSession()
  const items = await getAllOutboxItems()
  checkSession()
  const item = items.find((entry) => entry.id === itemId)
  if (!item || !["failed", "blocked"].includes(item.status)) {
    throw new Error("This action is no longer failed. Refresh the sync details and try again.")
  }
  await deleteOutboxItem(itemId)
  dispatch(discardSyncOperation(itemId))
}
